<template>
  <div class="device-config-instructions">
    <!-- Connection Info Section -->
    <div class="connection-info-section">
      <h4 class="section-subtitle">Данные для подключения</h4>
      <div class="connection-fields">
        <div class="connection-field">
          <label>Хост (IP-адрес):</label>
          <div class="copy-field">
            <code>{{ connection.host }}</code>
            <button type="button" class="btn-copy" @click="copyToClipboard(connection.host, 'Хост')">
              <i class="ni ni-single-copy-04"></i>
            </button>
          </div>
        </div>
        <div class="connection-field">
          <label>Порт:</label>
          <div class="copy-field">
            <code>{{ connection.port }}</code>
            <button type="button" class="btn-copy" @click="copyToClipboard(connection.port, 'Порт')">
              <i class="ni ni-single-copy-04"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Instructions Accordion -->
    <div class="instructions-accordion">
      <h4 class="section-subtitle">Инструкции по настройке</h4>

      <!-- iOS Instructions -->
      <div class="accordion-item" :class="{ 'expanded': expandedSection === 'ios' }">
        <button type="button" class="accordion-header" @click="toggleSection('ios')">
          <span class="platform-icon">
            <i class="fab fa-apple"></i>
          </span>
          <span class="platform-name">iPhone / iPad (iOS)</span>
          <span class="accordion-arrow">
            <i class="ni" :class="expandedSection === 'ios' ? 'ni-bold-up' : 'ni-bold-down'"></i>
          </span>
        </button>
        <transition name="accordion">
          <div v-if="expandedSection === 'ios'" class="accordion-content">
            <ol class="instruction-steps">
              <li>Откройте <strong>Настройки</strong> на вашем устройстве</li>
              <li>Перейдите в <strong>Wi-Fi</strong> и нажмите на значок <strong>(i)</strong> рядом с подключённой сетью</li>
              <li>Прокрутите вниз и нажмите <strong>Настроить прокси</strong></li>
              <li>Выберите <strong>Вручную</strong></li>
              <li>Введите:
                <ul>
                  <li>Сервер: <code>{{ connection.host }}</code></li>
                  <li>Порт: <code>{{ connection.port }}</code></li>
                </ul>
              </li>
              <li>Нажмите <strong>Сохранить</strong></li>
              <li>Установите сертификат (если ещё не установлен):
                <ul>
                  <li>Откройте Safari и перейдите по адресу <code>mitm.it</code></li>
                  <li>Скачайте профиль для iOS</li>
                  <li>Перейдите в <strong>Настройки → Основные → VPN и управление устройством</strong> и установите профиль</li>
                  <li>Перейдите в <strong>Настройки → Основные → Об этом устройстве → Доверие сертификатам</strong> и включите доверие для mitmproxy</li>
                </ul>
              </li>
            </ol>
          </div>
        </transition>
      </div>

      <!-- Android Instructions -->
      <div class="accordion-item" :class="{ 'expanded': expandedSection === 'android' }">
        <button type="button" class="accordion-header" @click="toggleSection('android')">
          <span class="platform-icon android">
            <i class="fab fa-android"></i>
          </span>
          <span class="platform-name">Android</span>
          <span class="accordion-arrow">
            <i class="ni" :class="expandedSection === 'android' ? 'ni-bold-up' : 'ni-bold-down'"></i>
          </span>
        </button>
        <transition name="accordion">
          <div v-if="expandedSection === 'android'" class="accordion-content">
            <ol class="instruction-steps">
              <li>Откройте <strong>Настройки</strong> на вашем устройстве</li>
              <li>Перейдите в <strong>Wi-Fi</strong> (или Сеть и интернет → Wi-Fi)</li>
              <li>Нажмите и удерживайте на подключённой сети, затем выберите <strong>Изменить сеть</strong></li>
              <li>Разверните <strong>Расширенные параметры</strong></li>
              <li>В разделе <strong>Прокси</strong> выберите <strong>Вручную</strong></li>
              <li>Введите:
                <ul>
                  <li>Имя хоста прокси: <code>{{ connection.host }}</code></li>
                  <li>Порт прокси: <code>{{ connection.port }}</code></li>
                </ul>
              </li>
              <li>Нажмите <strong>Сохранить</strong></li>
              <li>Установите сертификат (если ещё не установлен):
                <ul>
                  <li>Откройте браузер и перейдите по адресу <code>mitm.it</code></li>
                  <li>Скачайте сертификат для Android</li>
                  <li>Перейдите в <strong>Настройки → Безопасность → Установить из памяти</strong> (путь может отличаться)</li>
                  <li>Выберите скачанный файл и установите как CA-сертификат</li>
                </ul>
              </li>
            </ol>
            <div class="notice">
              <i class="ni ni-notification-70"></i>
              <span>На некоторых устройствах Android путь к настройкам может отличаться в зависимости от версии системы и производителя.</span>
            </div>
          </div>
        </transition>
      </div>
    </div>

    <!-- Copy notification -->
    <transition name="fade">
      <div v-if="copyNotification" class="copy-notification">
        <i class="ni ni-check-bold"></i>
        {{ copyNotification }}
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'DeviceConfigInstructions',
  props: {
    connection: {
      type: Object,
      required: true,
      default: () => ({
        host: '',
        port: ''
      })
    }
  },
  data() {
    return {
      expandedSection: null,
      copyNotification: null
    };
  },
  methods: {
    toggleSection(section) {
      this.expandedSection = this.expandedSection === section ? null : section;
    },
    async copyToClipboard(text, fieldName) {
      try {
        await navigator.clipboard.writeText(String(text));
        this.copyNotification = `${fieldName} скопирован`;
        setTimeout(() => {
          this.copyNotification = null;
        }, 2000);
      } catch (err) {
        console.error('Failed to copy:', err);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.device-config-instructions {
  position: relative;

  .section-subtitle {
    font-size: 1rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 1rem;
  }

  .connection-info-section {
    background-color: rgba(67, 97, 238, 0.05);
    border-radius: 8px;
    padding: 1.25rem;
    margin-bottom: 1.5rem;

    .connection-fields {
      display: flex;
      gap: 2rem;

      @media (max-width: 576px) {
        flex-direction: column;
        gap: 1rem;
      }
    }

    .connection-field {
      label {
        display: block;
        font-size: 0.875rem;
        color: #606266;
        margin-bottom: 0.5rem;
        font-weight: 500;
      }

      .copy-field {
        display: flex;
        align-items: center;
        gap: 0.5rem;

        code {
          background-color: #fff;
          padding: 0.5rem 1rem;
          border-radius: 4px;
          font-family: 'Courier New', monospace;
          font-size: 1rem;
          color: #4361EE;
          font-weight: 600;
          border: 1px solid #e9ecef;
        }

        .btn-copy {
          background: none;
          border: none;
          color: #4361EE;
          padding: 0.5rem;
          cursor: pointer;
          border-radius: 4px;
          transition: all 0.2s ease;

          &:hover {
            background-color: rgba(67, 97, 238, 0.1);
          }

          i {
            font-size: 1rem;
          }
        }
      }
    }
  }

  .instructions-accordion {
    .accordion-item {
      border: 1px solid #e9ecef;
      border-radius: 8px;
      margin-bottom: 0.75rem;
      overflow: hidden;
      transition: all 0.3s ease;

      &.expanded {
        border-color: #4361EE;
        box-shadow: 0 2px 8px rgba(67, 97, 238, 0.1);
      }

      .accordion-header {
        width: 100%;
        display: flex;
        align-items: center;
        padding: 1rem 1.25rem;
        background: none;
        border: none;
        cursor: pointer;
        text-align: left;
        transition: background-color 0.2s ease;

        &:hover {
          background-color: #f8f9fa;
        }

        .platform-icon {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background-color: #333;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 1rem;

          &.android {
            background-color: #3ddc84;
          }

          i {
            font-size: 1.1rem;
          }
        }

        .platform-name {
          flex: 1;
          font-weight: 600;
          color: #333;
          font-size: 0.95rem;
        }

        .accordion-arrow {
          color: #6c757d;

          i {
            font-size: 0.75rem;
          }
        }
      }

      .accordion-content {
        padding: 0 1.25rem 1.25rem;
        border-top: 1px solid #e9ecef;

        .instruction-steps {
          margin: 1rem 0 0;
          padding-left: 1.25rem;

          li {
            margin-bottom: 0.75rem;
            color: #606266;
            line-height: 1.6;

            &:last-child {
              margin-bottom: 0;
            }

            strong {
              color: #333;
            }

            code {
              background-color: rgba(67, 97, 238, 0.08);
              padding: 0.15rem 0.4rem;
              border-radius: 3px;
              font-family: 'Courier New', monospace;
              font-size: 0.85rem;
              color: #4361EE;
            }

            ul {
              margin-top: 0.5rem;
              padding-left: 1.25rem;

              li {
                margin-bottom: 0.4rem;
              }
            }
          }
        }

        .notice {
          display: flex;
          align-items: flex-start;
          gap: 0.75rem;
          margin-top: 1rem;
          padding: 0.75rem 1rem;
          background-color: rgba(255, 193, 7, 0.1);
          border-radius: 6px;
          color: #856404;
          font-size: 0.85rem;

          i {
            flex-shrink: 0;
            margin-top: 0.15rem;
          }
        }
      }
    }
  }

  .copy-notification {
    position: fixed;
    bottom: 2rem;
    left: 50%;
    transform: translateX(-50%);
    background-color: #52c41a;
    color: #fff;
    padding: 0.75rem 1.5rem;
    border-radius: 6px;
    font-weight: 500;
    font-size: 0.9rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 9999;
  }
}

// Accordion transition
.accordion-enter-active,
.accordion-leave-active {
  transition: all 0.3s ease;
  max-height: 500px;
  overflow: hidden;
}

.accordion-enter,
.accordion-leave-to {
  max-height: 0;
  opacity: 0;
  padding-top: 0;
  padding-bottom: 0;
}

// Fade transition
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
